import { FC, ReactNode } from "react";
import styles from "./ContentPanel.module.scss";
import classNames from "classnames";

interface Props {
  dataQA: string;
  className?: string;
  children: ReactNode;
}

const ContentPanel: FC<Props> = ({ dataQA, className, children }) => {
  return (
    <div data-qa={dataQA} className={classNames(styles.container, className)}>
      {children}
    </div>
  );
};

export default ContentPanel;
